import frTrans from "./fr.json";
let fr = {
  translations: frTrans,
};

export default fr;
